import { render, staticRenderFns } from "./EnrollFingerprints.vue?vue&type=template&id=f3130484&"
import script from "./EnrollFingerprints.vue?vue&type=script&lang=js&"
export * from "./EnrollFingerprints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports